// Хаб тренировки (#/train, макет 04): карточка «Зевки» с числом своих позиций +
// карточка «Дебюты» (скоро, disabled). Свои пазлы собираем из кэша разборов
// загруженных партий. Без партий в состоянии — уводим к списку.
import { t } from '../i18n';
import { state } from '../state';
import { ownPuzzlesFromGames } from '../services/puzzles';
import { showBackButton, hideMainButton } from '../tg';

function esc(s: string): string {
  return s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c] || c);
}

export function renderTrain(root: HTMLElement): void {
  if (!state.nick) {
    location.hash = '#/';
    return;
  }
  if (!state.games.length) {
    location.hash = '#/games';
    return;
  }

  const count = ownPuzzlesFromGames(state.games, state.nick).length;
  const blundersSub = count
    ? t('train.blunders_sub', { n: count })
    : t('train.blunders_empty_sub');

  root.className = 'app v2';
  root.innerHTML = `
    <header class="topbar">
      <span class="back" data-back>${t('top.back')}</span>
      <span class="top-title"><span class="top-logo" aria-hidden="true"></span>${t('train.title')}</span>
      <span class="top-action">${esc(state.nick)}</span>
    </header>

    <section class="train-hero">
      <div class="eyebrow">${t('train.eyebrow')}</div>
      <h1>${t('train.header')}</h1>
      <p class="muted">${t('train.subtitle')}</p>
    </section>

    <section class="train-entry-list" aria-label="${t('train.modes')}">
      <button type="button" class="card train-entry" data-go-blunders>
        <span class="train-icon">??</span>
        <span class="grow">
          <strong>${t('train.blunders_title')}</strong>
          <span class="muted">${esc(blundersSub)}</span>
        </span>
        <span class="muted">›</span>
      </button>

      <button type="button" class="card train-entry" data-go-openings>
        <span class="train-icon opening">c3</span>
        <span class="grow">
          <strong>${t('train.openings_title')}</strong>
          <span class="muted">${t('train.openings_sub')}</span>
        </span>
        <span class="muted">›</span>
      </button>
      <button type="button" class="card train-entry" data-go-my>
        <span class="train-icon my-icon">MY</span><span class="grow"><strong>${t('my.title')}</strong><span class="muted">${t('my.train_sub')}</span></span><span class="muted">›</span>
      </button>
    </section>

    <aside class="train-fallback">${t('train.fallback')}</aside>`;

  hideMainButton();
  const toGames = (): void => {
    location.hash = '#/games';
  };
  showBackButton(toGames);
  root.querySelector<HTMLElement>('[data-back]')?.addEventListener('click', toGames);
  root.querySelector<HTMLElement>('[data-go-blunders]')?.addEventListener('click', () => {
    location.hash = '#/train/blunders';
  });
  root.querySelector<HTMLElement>('[data-go-openings]')?.addEventListener('click', () => {
    location.hash = '#/train/openings';
  });
  root.querySelector<HTMLElement>('[data-go-my]')?.addEventListener('click', () => { location.hash = '#/train/my'; });
}
